// extracted by mini-css-extract-plugin
export default {"sub_title":"index_sub_title_gK4ni"};